<template>
<a-space direction="vertical">
<!-- <a-card class="order-manage-create-page"> -->
    <div class="address-choose">
        <a-button type="link" @click="handleSelect">
        <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
    </div>
    <div>
        <a-row >
            <a-col :md="8" :sm="24">
                <FormItemNameNo
                    v-model.trim="endStation.contactName"
                    :prop-prefix="propPrefix"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <FormItemPhoneNo
                    v-model="endStation.contactPhone"
                    :prop-prefix="propPrefix"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <a-form-model-item
                    label="期望送达时间"
                    :prop='`${propPrefix}.expectTime`'
                    :label-col="{span: 6}"
                    :wrapper-col="{span: 16}"
                >
                    <a-date-picker
                    v-model="endStation.expectTime"
                    :show-time="{ defaultValue: defaultTime }"
                    placeholder="请选择送达时间" />
                </a-form-model-item>
            </a-col>
            <a-col :md="16" :sm="24">
                <!-- <FormItemAddressNo
                    :address="endStation"
                    :prop-prefix="propPrefix"
                    @change="handleAdressChange" /> -->
                <a-form-model-item
                    label="联系人地址"
                    :label-col="{span: 3}"
                    :wrapper-col="{span: 16}"
                    :rules="addressRules"
                    :prop="`${propPrefix}.address`"
                >
                    <address-detil
                    :default-address="defaultAddress"
                    :default-suffix="defaultSuffix"
                    placeholder="请输入目的地地详细地址"
                    @updateData="handleAdressChange"
                    @removeData="removeData"></address-detil>
                </a-form-model-item>
            </a-col>
        </a-row>
        <slot></slot>
    </div>
<!-- </a-card> -->
<SelectAddressDialog ref="SelectAddressDialog" :station-type="StationTypes.RECEIVING" @onSelectAddress="handleAdressFromSelectorChange"/>
 </a-space>
</template>
<script>
import moment from 'moment';
import FormValidator from '@/constants/formValidator'
import SelectAddressDialog from '../../../orderManage/components/SelectAddressDialog'
import { StationTypes } from '../../warehouseList/constant';

import {
    FormItemNameNo,
    FormItemPhoneNo,
    // FormItemAddressNo
} from '../../../orderManage/components/FormItem'
import AddressDetil from './AddressDetil.vue'

const warehouseType = {
    in: 'STORE',
    out: 'DELIVER'
}

export default {
    components: {
        SelectAddressDialog,
        FormItemNameNo,
        FormItemPhoneNo,
        AddressDetil,
        // FormItemAddressNo,
    },
    model: {
        prop: 'endStation',
        event: 'change'
    },
    props: {
        endStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        propPrefix: {
            type: String,
            default: ''
        },
        scene: {
            type: String,
            default: ''
        },
        deliverWarehouseCode: {
            type: String,
            default: ''
        },
        shipperCode: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            defaultTime: moment('23:59:59', 'HH:mm:ss'),
            col: 8,
            wrapperCol: 14,
            FormValidator,
            StationTypes,
            addressRules: [],
            defaultAddress: '',
            defaultSuffix: '',
        }
    },
    watch: {
        endStation:{
            handler(val){
                if(val.address){
                    this.defaultSuffix = `${val.provinceName}${val.cityName}${val.countyName}${val.address}`
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                } else {
                    this.defaultSuffix = ''
                    this.defaultAddress = ''
                }
            },
            immediate: true
        },
    },
    methods: {
        handleSelect() {
            if(this.scene === warehouseType.out){
                if(!this.deliverWarehouseCode) {
                    this.$message.warning('请先选择仓库')
                    return
                }
                this.$refs.SelectAddressDialog.show({
                    data: true,
                    ownerTenantId: this.deliverWarehouseCode,
                    customerCode: this.shipperCode
                })
            } else {
                this.$refs.SelectAddressDialog.show({})
            }
        },
        handleAdressFromSelectorChange({
            contacts, telPhone,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode, sourceStationId, maxReceiptPeriodTime
        }) {
            this.update({
                contactPhone: telPhone,
                contactName: contacts,
                provinceName,
                cityName,
                countyName,
                address,
                provinceCode,
                cityCode,
                countyCode,
                stationId: sourceStationId,
                // stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
            // 该站点是否已有收货时段,期望送达时间的结束时间
            if(maxReceiptPeriodTime) {
                this.defaultTime = moment(`${maxReceiptPeriodTime}:00`, 'HH:mm:ss')
            } else {
                this.defaultTime = moment('23:59:59', 'HH:mm:ss')
            }
        },
        handleAdressChange(address) {
            this.update(address)
        },
        update(infos) {
            const {provinceName, cityName, countyName, address} = infos
            this.$emit('change', {
                ...this.endStation,
                ...infos,
                stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm} = this.endStation
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType: 0,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
                stationGoodsList: []
            })
        },
    },
}
</script>

<style lang="less" scoped>
.address-choose {
    padding-left: 32px;
    margin-bottom: 19px;
    .ant-btn {
        padding: 0;
    }
}
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    .subtitle {
        flex: 1;
    font-weight: bold;
    font-size: 16px;
    }

}
/deep/ .subtitle-label {
    margin-bottom: 10px;
}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
.btnStyle{
    margin-top: 8px;
}
/deep/ .ant-space-item{
    margin-bottom: 0 !important;
}
/deep/ .orderNumStyle{
    max-width: 302px !important;
    width: 100%;
}
</style>
